import { Box, Card, Grid2, Skeleton, Stack } from '@mui/material'
import { memo } from 'react'

import stakingIcon from 'assets/staking-icon.png'
import { Image } from 'src/components/shared/image'
import RefreshButton from 'src/components/shared/button/RefreshButton'
import CardHeading from 'src/components/shared/text/CardHeading'
import { formatCurrencyShort } from 'src/util/number.helpers'
import { formatQBXCurrency } from 'src/util/staking/staking.helpers'
import StakeUnlockTimer from '../common/StakeUnlockTimer'
import SummaryWidget from './SummaryWidget'

const ClaimStaking = ({
  t,
  onStakedClaim,
  userTier,
  stakingProfile: {
    stakedQBX,
    endTime,
    startTime,
    stakingInfoProcessing,
    userTierLoading
  },
  onRefreshUserTier
}) => {
  return (
    <Card
      sx={{
        p: 3
      }}
    >
      <CardHeading title={t('brand:staking.staked')} />
      <Stack spacing={3}>
        <Grid2 container spacing={3}>
          <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
            <SummaryWidget
              title={t('brand:staking.amount-staked')}
              value={
                stakingInfoProcessing ? (
                  <Skeleton width='40%' height={40} />
                ) : (
                  formatQBXCurrency(stakedQBX)
                )
              }
              icon={
                <Box
                  sx={{
                    width: 120,
                    height: 120,
                    lineHeight: 0,
                    borderRadius: '50%',
                    bgcolor: 'background.neutral',
                    overflow: 'visible',
                    position: 'relative'
                  }}
                >
                  <Image
                    src={stakingIcon}
                    sx={{
                      position: 'absolute',
                      top: '-15px',
                      left: '-5px',
                      width: '146px',
                      height: '146px'
                    }}
                  />
                </Box>
              }
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
            <SummaryWidget
              title={t('brand:staking.value-of-staked')}
              value={`$${userTier.totalFiatValue && stakedQBX > 0 ? formatCurrencyShort(userTier.totalFiatValue, 2) : 0}`}
              helpText={t('brand:staking.value-of-staked-help')}
              action={
                <RefreshButton
                  t={t}
                  size='small'
                  onClick={onRefreshUserTier}
                  disabled={!stakedQBX > 0}
                  loading={userTierLoading}
                  variant='outlined'
                />
              }
            />
          </Grid2>
        </Grid2>
        <StakeUnlockTimer
          t={t}
          stakedQBX={stakedQBX}
          startTime={startTime}
          endTime={endTime}
          onStakedClaim={onStakedClaim}
        />
      </Stack>
    </Card>
  )
}

export default memo(ClaimStaking)
